import React, { useState } from "react";
import "./Card.css";
import WishListIcon from "../WishlistIcon/WishListIcon";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProductCardCartBtn from "../ProductCardCartBtn/ProductCartCardBtn";

const ProductCard = ({
  cardcartbtn,
  namefontsize,
  categoryfontsize,
  product = {},
}) => {
  const colors = useSelector((state) => state.color.colors);
  const wishlist = useSelector((state) => state.wishlist.products);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [isHoveredAddToCart, setIsHoveredAddToCart] = useState(false);

  /** 🧩 Extract product fields safely */
  const {
    _id,
    name = "",
    defaultImageUrl,
    defaultPrice,
    mrp,
    discountPercentage,
    gender,
    livePrice,
    purity,
    categories = [],
    colors: productColors = [],
    coloredImages = [],
  } = product;

  /** 💰 Calculate display price logic */
  const price = livePrice || defaultPrice || mrp || 0;
  const discount =
    discountPercentage && discountPercentage > 0
      ? Math.round(price - price * (discountPercentage / 100))
      : null;

  /** 🖼️ Choose primary display image */
  const mainImage =
    defaultImageUrl ||
    (coloredImages?.[0]?.images?.[0] ?? "/assets/images/placeholder.png");

  /** 💎 Category name (safe) */

  let categoryName = "Jewellery";
  categories?.map(c => {
    if (c.parent) {
      categoryName = c.name;
    }
  })

  /** 🩷 Wishlist state */
  const isWishlisted = wishlist.some((wh) => wh._id === _id);

  /** 🪞 Hover interactions (kept for UI effects) */
  const handleMouseEnter = (btn) =>
    btn === "addtocart" && setIsHoveredAddToCart(true);
  const handleMouseLeave = (btn) =>
    btn === "addtocart" && setIsHoveredAddToCart(false);

  return (
    <div className="productcardcontainer">
      {/* 🖼️ Image + Wishlist */}
      <div className="cardimageandheart">
        <img
          className="cardimage"
          src={mainImage}
          alt={name}
          onClick={() =>
            navigate(`/${name.replaceAll(" ", "-")}/${_id}`)
          }
          loading="lazy"
        />
        {
          user ?
            <WishListIcon
              isWishlist={product?.isWishlist}
              id={_id}
              pagename="productlist"
            />
            :
            null
        }

      </div>

      {/* 📄 Product Info */}
      <div
        className="product-card-details"
      // onClick={() => navigate(`/${name.replaceAll(" ", "-")}/${_id}`)}
      >
        <div className="ellipsis">
          <h4 className={`cardtitle ${namefontsize || "t7"}`}>
            {name.slice(0, 60)}
          </h4>

          {/* 💰 Price Display */}
          <div className="productcard-price">
            {discount ? (
              <>
                <h5 className={`${namefontsize || "t7"} canceledmrp`}>
                  ₹ {price.toLocaleString()}
                </h5>
                <h5 className={`${namefontsize || "t7"}`}>
                  ₹ {discount.toLocaleString()}
                </h5>
              </>
            ) : (
              <h5 className={`${namefontsize || "t7"}`}>
                ₹ {price.toLocaleString()}
              </h5>
            )}
          </div>

          {/* 💎 Meta Info */}
          <h6
            className={`${categoryfontsize || "t8"
              }   cardcategorytext`}
          >
            <small className="card-text">
              {gender
                ? gender.charAt(0).toUpperCase() + gender.slice(1)
                : "Women"}{" "}
              | {categoryName} {purity ? `| ${purity}` : ""}
            </small>
          </h6>
        </div>

        {/* 🎨 Gold Colors / Variants */}
        {productColors?.length > 0 && (
          <div className="productcard-color">
            <div className="product-colors">
              {productColors.slice(0, 2).map((color, index) => (
                <div
                  key={index}
                  className="colouredcircle"
                  style={{
                    backgroundColor:
                      colors?.colors?.[color]?.colorCode || "#d4af37",
                  }}
                  title={color}
                ></div>
              ))}
              {productColors.length > 2 && (
                <div className="t8 font-semibold">
                  +{productColors.length - 2}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* 🛒 Add to Cart Button */}
      {/* <ProductCardCartBtn
        name={cardcartbtn || "Quick Add"}
        product={product}
      /> */}
    </div>
  );
};

export default ProductCard;
